import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@modules/material.module';
import { PrimengModule } from '@modules/primeng.module';
import { SharedModule } from '../../shared.module';
import { ExibeCorrespondenciaDialogComponent } from './exibe-correspondencia-dialog.component';
import { CorrespondenciaTableComponent } from './correspondencia-table/correspondencia-table.component';

@NgModule({
  declarations: [
    ExibeCorrespondenciaDialogComponent,
    CorrespondenciaTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    PrimengModule,
  ],
  exports: [
    ExibeCorrespondenciaDialogComponent,
  ],
})
export class ExibeCorrespondenciaDialogModule { }
